import React, { Component } from 'react';
import AnimatedWrapper from '../animated-wrapper';
import refresh from '../../../assets/images/refresh.png';

import './page-not-found.css';

class PageNotFound extends Component {
  render() {
    return (
      <div className='regular-page page-not-found-page'>
        <div className='content-container'>
          <p>
            Something went wrong.
          </p>
          <p>
            Please try to refresh or navigate to another page.
          </p>
          <img 
            src={refresh} 
            className='refresh-img' 
            title='please refresh' 
            alt='please refresh' />
        </div>
      </div>    
    );  
  }
};

const AnimatedPageNotFound = AnimatedWrapper(PageNotFound);
export default AnimatedPageNotFound;
